import { useState } from 'react';
import { Button, Typography, Box, Card } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { LoginDialog } from '../auth/login/loginDialog';
import { useRouteNavigator } from '../../routes/useRouteNavigator';
import { useTranslation } from 'react-i18next';

interface LoginRegisterProps {
  isSmallFont?: boolean;
  disableHeader?: boolean;
  onRegisterClick?: () => void;
}

const LoginRegister = ({ isSmallFont, disableHeader, onRegisterClick }: LoginRegisterProps) => {
  const theme = useTheme();
  const routeNavigator = useRouteNavigator();
  const { t } = useTranslation();
  const [openLogin, setOpenLogin] = useState(false);

  const handleLoginClick = () => setOpenLogin(true);
  const closeLogin = () => setOpenLogin(false);
  const handleRegisterClick = () => {
    onRegisterClick?.();
    routeNavigator.goToRegistration();
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Card
        sx={{
          borderRadius: '10px',
          p: '15px 15px 10px 15px',
        }}
      >
        <Box display="flex" flexDirection="column" gap={2}>
          {!disableHeader && (
            <Typography variant={isSmallFont ? 'subtitle1' : 'h6'} sx={{ fontWeight: 'bold' }}>
              {t('account:areYouOurFriend')}
            </Typography>
          )}
          <Typography variant={isSmallFont ? 'body2' : 'body1'}>
            {t('account:loginAndGetDiscountPart1')}
            <span style={{ color: theme.palette.secondary.main }}>{t('account:loginAndGetDiscountPart2')}</span>
            {t('account:loginAndGetDiscountPart3')}
          </Typography>
          <Grid container sx={{ maxWidth: '600px' }} columnSpacing={2}>
            <Grid size={{ xs: 'grow' }} sx={{ pb: '10px', minWidth: '150px' }}>
              <Button
                variant="outlined"
                sx={{
                  borderColor: theme.palette.secondary.main,
                  color: theme.palette.secondary.main,
                  backgroundColor: theme.palette.secondary.contrastText,
                  width: '100%',
                  minWidth: '130px',
                  padding: { xs: '5px 10px', sm: '5px 15px' },
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                    boxShadow: 'none',
                    borderColor: theme.palette.secondary.dark,
                  },
                  fontSize: isSmallFont && '14px',
                }}
                onClick={handleLoginClick}
              >
                {t('account:login')}
              </Button>
            </Grid>
            <Grid size={{ xs: 'grow' }} sx={{ pb: '10px', minWidth: '150px' }}>
              <Button
                variant="contained"
                sx={{
                  width: '100%',
                  minWidth: '130px',
                  padding: { xs: '5px 10px', sm: '5px 15px' },
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: theme.palette.secondary.dark,
                    boxShadow: 'none',
                  },
                  fontSize: isSmallFont && '14px',
                }}
                onClick={handleRegisterClick}
              >
                {t('account:becomeFriend')}
              </Button>
            </Grid>
          </Grid>
          <LoginDialog open={openLogin} onClose={closeLogin} allowAnonymous />
        </Box>
      </Card>
    </Box>
  );
};

export default LoginRegister;
